/**
 * Time-parser helper — extracted from ``ConversationsV2Page.jsx``
 * so siblings (MessageBubble, SidebarRow, MessageList…) can import
 * it without depending on the giant page module.
 *
 * Backend MySQL DATETIME columns historically returned naive ISO
 * strings ("2026-05-01T19:51:47.968"). The conversation backend now
 * appends a 'Z' for UTC, but legacy callers + cached blobs may not.
 * This helper normalises to a Date in the viewer's local zone:
 *
 *   - If the string already has 'Z' or '+HH:MM' / '-HH:MM' → pass through.
 *   - Otherwise, append 'Z' so the browser parses it as UTC.
 *   - Date-only strings ("YYYY-MM-DD") are passed through.
 */
export function parseServerTime(s) {
  if (!s) return null;
  if (typeof s !== "string") return new Date(s);
  if (s.length <= 10) return new Date(s);
  const hasTz = /Z|[+-]\d{2}:?\d{2}$/.test(s);
  return new Date(hasTz ? s : s + "Z");
}
